import { render, staticRenderFns } from "./RedactorTable.vue?vue&type=template&id=238f49ad&scoped=true&"
import script from "./RedactorTable.vue?vue&type=script&lang=js&"
export * from "./RedactorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f49ad",
  null
  
)

export default component.exports